import { data } from 'jquery';
import React, { useState, useEffect } from 'react';
import { AddRevenue } from '../../Redux/action/revenueAction';
import Select from 'react-select';
import './form.css';
import {
  allLocationWithShortName,
  dataUser,
  spocLocationDetailsZoho,
} from '../Helpers/util';
import { AddInternetService } from '../../Redux/action/internetAction';
import { getLocationNameById } from '../../utils/getLocationNameById';
import { toast } from 'react-toastify';
import moment from 'moment';
import SwTextArea from '../Common/FormComponent/SwTextArea';
import SwInput from '../Common/FormComponent/SwInput';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';
import dayjs from 'dayjs';



const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal12 = spocLocationDetailsZoho();
const locationWithShortName = allLocationWithShortName();

let count = 0;

class InternetService extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notes: '',
      func: [
        {
          service_type: '',
          bandwidth: '50',
          start_date: '',
          end_date: '',
        },
      ],
      location: '',
      location1: '',
      locationData: [],
      locationNew: [],
      locationId: null,
      locationError: '',
      modal: false,
      dynamicFieldError: false,
      files: null,
      attachmentError: '',
      btnStatus: false,
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: '',
    };
  }
  changeSelect = e => {
    if (!e) {
      this.setState({
        location: null,
        location1: '',
        locationId: '',
        locationError: '',
      });
      return;
    }

    this.setState({
      location: e,
      location1: String(e.label),
      locationId: e.value,
      locationError: '',
    });
  };

  componentDidMount() {
    var LocationSpoc = JSON.parse(userDataLocal12);
    let locationShort = JSON.parse(locationWithShortName);
    this.setState({ locationNew: locationShort });
    this.setState({ locationData: LocationSpoc });
  }

  onServiceChange = (e, index) => {
    let tempState = [...this.state.func];
    tempState[index]['service_type'] = e?.value;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };

  onCompanyChange = (e, index) => {
    let tempState = [...this.state.func];
    tempState[index]['vendor_name'] = e?.value;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };
  onStartDate = (e, i) => {
    let tempState = [...this.state.func];
    tempState[i]['start_date'] = e?.target?.value;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };
  onEndDate = (e, i) => {
    const selectedEndDate = e?.target?.value;
    let tempState = [...this.state.func];
    const startDate = tempState[i]['start_date'];

    // Check if the start date is selected
    if (!startDate) {
      toast.error('Please select the Start Date first.');
      return;
    }

    // Validate that the end date is not earlier than the start date
    if (selectedEndDate < startDate) {
      toast.error('End Date cannot be earlier than Start Date.');
      return;
    }

    // Update the state if all validations pass
    tempState[i]['end_date'] = selectedEndDate;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };

  onBandwidthChange = (e, index) => {
    let tempState = [...this.state.func];
    tempState[index]['bandwidth'] = parseFloat(e?.target?.value);
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };
  onNotes = e => {
    this.setState({
      notes: e?.target?.value,
    });
  };
  resetValue = () => {
    this.setState({
      location: '',
      notes: '',
      func: [
        {
          service_type: '',
          bandwidth: '',
          start_date: '',
          end_date: '',
        },
      ],
      locationError: '',
      dynamicFieldError: false,
      attachmentError: '',
    });
    count = 0;
    this.setState({
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: '',
    });
  };
  removeFormFields(i) {
    let formValues = this.state.func;
    formValues.splice(i, 1);
    this.setState({ formValues });
  }

  handleFile(e) {
    if (e.target.files[0]) {
      this.setState({
        selectedFile: e.target.files[0],
        selectedFileName: e.target.files[0].name,
        imageSrc: window.URL.createObjectURL(e.target.files[0]),
        value: e.target.value,
      });
    }

    // Getting the files from the input
    this.setState({ files: e.target.files });

    if (e.target.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    } else if (e.target.files.length <= 2) {
      this.setState({ attachmentError: '' });
    }
  }

  handleSubmit = e => {
    e.preventDefault();

    let files = this.state.files;
    let formData = new FormData();
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        formData.append('file', files[i]);
      }
    }

    let dynamicFieldError = false;
    let dateError = false;

    this.state.func.forEach(item => {
      // Check if service_type and bandwidth are filled
      if (!(item.service_type && item.bandwidth)) {
        dynamicFieldError = true;
      } else if (item.bandwidth < 0) {
        dynamicFieldError = true;
      }

      // Check if start and end dates are valid
      if (!item.start_date || !item.end_date) {
        dateError = true;
        toast.error('Please select both Start Date and End Date.');
      } else if (new Date(item.end_date) < new Date(item.start_date)) {
        dateError = true;
        toast.error('End Date cannot be earlier than Start Date.');
      }
    });

    if (this.state.location1 === null || this.state.location1 === '') {
      this.setState({ locationError: "Location can't be empty" });
    }

    // Halt submission if there are any errors
    if (dynamicFieldError || dateError || this.state.location1 === '') {
      this.setState({ dynamicFieldError: dynamicFieldError });
      return;
    }

    if (this.state.files != null && this.state.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
      return;
    }

    if (this.state.location1 !== '' && !dynamicFieldError && !dateError) {
      let param = {};
      let common_param = {
        company_id: UserObj ? UserObj.company_id : null,
        spoc_id: UserObj ? UserObj.rec_id : null,
        email: UserObj ? UserObj.email : null,
        category: 'internet_service',
        company_name: UserObj ? UserObj.company_name : null,
      };
      let body_param = {
        internet_service: this.state.func,
        notes: this.state.notes,
        location_name: this.state.location1,
      };
      param.common_param = common_param;
      param.body_param = body_param;

      // Call the API to add the revenue
      // AddRevenue(param, this.props.onClose)
      //   .then(() => {
      //     // success handled by onClose
      //     this.setState({ btnStatus: false });
      //     e.currentTarget.disabled = false;
      //   })
      //   .catch(() => {
      //     // error toast already shown in AddRevenue
      //     this.setState({ btnStatus: false });
      //     e.currentTarget.disabled = false;
      //   });
      // e.currentTarget.disabled = false;

      AddRevenue(param, (success, message) => {
        if (success) {
          toast.success(message);
          this.resetValue();
          if (this.props.onClose) {
            this.props.onClose();
          }
        }
        this.setState({ btnStatus: false });
        e.currentTarget.disabled = false;
      });

      // Reset the form state after successful submission
      this.setState({
        notes: '',
        date: '',
        func: [
          {
            service_type: '',
            bandwidth: '',
            company: '',
            start_date: '',
            end_date: '',
          },
        ],
        locationError: '',
        dynamicFieldError: false,
        attachmentError: '',
        btnStatus: false,
        selectedFile: undefined,
        selectedFileName: undefined,
        imageSrc: undefined,
        value: '',
        modal: false,
      });
    }
  };

  render() {
    const options1 = [
      { value: 'Tata', label: 'Tata' },
      { value: 'Airtel', label: 'Airtel' },
      { value: 'Primenet', label: ' Primenet' },
      { value: 'Shah', label: ' Shah' },
      { value: 'Any of Above', label: 'Any of Above' },
    ];
    const options2 = [
      { value: 'shared', label: 'Shared' },
      { value: 'dedicated', label: 'Dedicated' },
    ];
    return (
      <>
        <div className="row">
          <div className="col-md-12">
            <div className="SwFormGroup">
              <label className="SwFormLabel">
                Location <span className="Required">*</span>
              </label>
              <SwSelect
                name="location"
                id="internet-location-select"
                onChange={this.changeSelect}
                value={this.state.location}
                options={this.state.locationData}
              />
              {''}
              <span className="SwTextDanger SwTextSmall">{this.state.locationError}</span>
            </div>
          </div>
        </div>
        <div className="row">
          {this.state.func.map((item, index) => {
            return (
              <>
                <div className="col-md-12">
                  <div className="event1 row">
                    <div className="col-md-6">
                      <div className="SwFormGroup">
                        <label className="SwFormLabel">
                          Service Type <span className="Required">*</span>
                        </label>
                        <SwSelect
                          placeholder="Select"
                          options={options2}
                          key={`key-${index}`}
                          id={`service-type-select-${index}`}
                          value={options2.filter(
                            option => option.value === item.service_type,
                          )}
                          onChange={e => this.onServiceChange(e, index)}
                        />
                        {this.state.dynamicFieldError && !item.service_type && (
                          <span className="SwTextDanger SwTextSmall">
                            {"Service type can't be Empty"}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="SwFormGroup">
                        <label className="SwFormLabel">
                          Bandwidth (Mbps) <span className="Required">*</span>
                        </label>
                        <SwInput
                          type="number"
                          id="internet-bandwidth-input"
                          min="50"
                          value={item.bandwidth}
                          onChange={e => this.onBandwidthChange(e, index)}
                        />
                        {(item.bandwidth < 0 ||
                          (this.state.dynamicFieldError &&
                            !item.bandwidth)) && (
                            <span className="SwTextDanger SwTextSmall">
                              {"Bandwidth can't be Empty or negative"}
                            </span>
                          )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      {' '}
                      <div className="SwFormGroup">
                        <label className="SwFormLabel">
                          Start Date <span className="Required">*</span>
                        </label>{' '}
                        <AntDDatePicker
                          value={item.start_date ? dayjs(item.start_date, 'YYYY-MM-DD') : null}
                          format="DD/MM/YYYY"
                          placeholder="Select start date"
                          disabledDate={(current) =>
                            current && current.isBefore(dayjs().startOf('day'))
                          }
                          onChange={(date) => {
                            let tempState = [...this.state.func];
                            tempState[index]['start_date'] = date
                              ? date.format('YYYY-MM-DD')
                              : '';
                            tempState[index]['end_date'] = ''; // reset end date if start changes

                            this.setState({
                              func: tempState,
                              dynamicFieldError: false,
                            });
                          }}
                          allowClear={false}
                        />

                      </div>
                      {this.state.dynamicFieldError && !item.start_date && (
                        <span
                          className="SwTextDanger"
                          style={{ fontSize: '11px' }}
                        >
                          {"Start Date can't be Empty"}
                        </span>
                      )}
                    </div>{' '}
                    <div className="col-md-6 ">
                      {' '}
                      <div className="SwFormGroup">
                        <label className="SwFormLabel">
                          End date <span className="Required">*</span>
                        </label>{' '}
                        <AntDDatePicker
                          value={item.end_date ? dayjs(item.end_date, 'YYYY-MM-DD') : null}
                          format="DD/MM/YYYY"
                          placeholder="Select end date"
                          disabledDate={(current) => {
                            if (!current) return false;

                            const startDate = item.start_date
                              ? dayjs(item.start_date, 'YYYY-MM-DD')
                              : null;

                            // Must select start date first
                            if (!startDate) return true;

                            // End date >= start date
                            if (current.isBefore(startDate, 'day')) return true;

                            // Optional: limit to +30 days from start date
                            if (current.isAfter(startDate.add(30, 'day'), 'day')) return true;

                            return false;
                          }}
                          onChange={(date) => {
                            if (!item.start_date) {
                              toast.error('Please select the Start Date first.');
                              return;
                            }

                            let tempState = [...this.state.func];
                            tempState[index]['end_date'] = date
                              ? date.format('YYYY-MM-DD')
                              : '';

                            this.setState({
                              func: tempState,
                              dynamicFieldError: false,
                            });
                          }}
                          allowClear={false}
                        />

                      </div>
                      {this.state.dynamicFieldError && !item.end_date && (
                        <span
                          className="SwTextDanger"
                          style={{ fontSize: '11px' }}
                        >
                          {"End date can't be Empty"}
                        </span>
                      )}
                    </div>
                    <div className="MP_AddMoreContainer mb-2">
                      {index == 0 ? (
                        <div>
                          <a
                            type="button"
                            style={
                              count + 1 < options2.length
                                ? { color: '#0571c4' }
                                : { color: '#63b4f2' }
                            }
                            className="SwLinkInfo"
                            onClick={() => {
                              let tempState = [...this.state.func];
                              tempState.push({
                                service_type: '',
                                bandwidth: '',
                              });
                              this.setState({
                                func: tempState,
                              });
                              {
                                count = count + 1;
                              }
                            }}
                            disabled={
                              count + 1 < options2.length ? false : true
                            }
                          >
                            <i class="bi bi-plus-circle" />{' '} 
                            Add More
                          </a>
                        </div>
                      ) : (
                        <div>
                          <a
                            type="button"
                            className="SwLinkDanger"
                            onClick={() => {
                              this.removeFormFields(index);
                              {
                                count = count - 1;
                              }
                            }}
                          >
                            <i class="bi bi-trash3-fill"></i>
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>

        <div className="row">
          <div className="col-md-12 mt-3">
            <div className="col-md-12 mt-2">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Notes</label>
                <SwTextArea
                  rows="4"
                  value={this.state.notes}
                  onChange={this.onNotes}
                  id="internet-bandwidth-notes"
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default InternetService;
